// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.complain_container__SVnbL {
  /* padding-top: 22px; */
  /* background-color: #f5f5f5; */
  min-height: calc(100% - 88px);
}



/* Top Header Section */
.complain_topHeader__kEX1z {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  padding: 20px 0 24px 0;

  border-radius: 12px;
  color: white;
}

.complain_globalBadge__qgLKr {
  background-color: #e0f2fe;
  /* Light blue background */
  color: #0369a1;
  /* Dark blue text */
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  display: inline-block;
}

.complain_noglobalBadge__YQTh7 {
  background-color: #FEF9C3;
  color: #CA8A04;
  /* Dark blue text */
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  display: inline-block;
}


.complain_headerLeft__sq8Ck {
  flex: 1 1;
}

.complain_container__SVnbL .css-rhb7ah-MuiInputBase-input-MuiOutlinedInput-input {
  background: #fff !important;
}

.complain_container__SVnbL .css-w75fiz-MuiInputBase-root-MuiOutlinedInput-root {
  background: #fff !important;
}

.complain_complaintheaderParents__npqPc {
  border-bottom: 1px solid #d2d9e3;
  margin-bottom: 24px;
}

.complain_headContainer__WtstL {
  display: flex;
  margin-bottom: 0;
  /* gap: 20px; */
  border-radius: 0;
  padding: 0 0 0 4px;
  font-size: 20px;
  overflow-x: auto;
  /* smooth scrolling */
  scrollbar-width: none;
  /* Firefox */
}

.complain_headContainer__WtstL::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Edge */
}

.complain_headContainer__WtstL>.complain_tab__KqMj5 {
  font-family: 'Inter';
  font-weight: 400;
  font-size: 14px;
  line-height: 30px;
  letter-spacing: 0%;
  padding: 10px 14px;
  /* min-width: 251px; */
  gap: 10px;
  color: #94a3b8;
  display: flex;
  justify-content: space-between;
  border-bottom: 3px solid transparent;
  margin-bottom: -1px;
}

.complain_tab1__1OKk3 {
  min-width: 180px !important;
}

.complain_relovedComplaintsTab__0ZFdG {
  min-width: 180px !important;
}

.complain_headContainer__WtstL>.complain_tab__KqMj5>.complain_count__mXlna {
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: 24px; */
  height: 20px;
  /* border-radius: 50%; */
  border-radius: 100px;
  padding: 2px 4px;

  background: #ef4444;
  font-family: 'Inter';
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0%;
  color: white;
}

.complain_headContainer__WtstL>.complain_tab__KqMj5:hover {
  color: #8b5cf6;
}

.complain_headContainer__WtstL>.complain_activeTab__KX9Yg {
  font-weight: 600;
  color: #8b5cf6;
  border-bottom-color: #8b5cf6;
  box-shadow: none !important;
}

.complain_tab__KqMj5 {
  display: flex;
  min-width: 56px;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  border: none;
  width: 100%;
  max-width: max-content;
  background: transparent;

  /* border-radius: 6px; */
  cursor: pointer;
  transition: all 0.2s ease;
  /* flex: 1; */

  text-align: center;

  /* Inter/Body small/Body small - medium */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  /* 142.857% */
}

.complain_tab__KqMj5:hover {
  background-color: transparent;
  color: #625be7;
}

.complain_mainTitle__XmYwY {
  color: var(--Slate-800, #1e293b);

  /* Inter/Heading 6/Heading 6 - semibold */
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  /* 133.333% */
}

.complain_subtitle__xxh1I {
  color: var(--Slate-500, #64748b);

  /* Inter/Body small/Body small - regular */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 142.857% */
}

.complain_uploadButton__9xrcV {
  color: white;
  padding: 12px 24px;
  color: var(--White, #fff);
  /* font-family: "Public Sans"; */
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  /* 142.857% */
  border-radius: 8px;
  background: var(--Violet, #644ee5);
  transition: all 0.3s ease;
}

.complain_uploadButton__9xrcV:hover {
  background-color: #4e38b3;
  transform: translateY(-2px);
}

/* Main Content Area */
.complain_mainContent__wTJ2X {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px 24px 24px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.complain_contentHeader__Mmt1M {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
}

.complain_contentTitle__GhhNX {
  color: var(--Slate-800, #1e293b);

  /* Inter/Body xl/Body xl - semibold */
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* 150% */
}

.complain_searchField__1vEZ6 {
  width: 100%;
}

.complain_searchField__1vEZ6 .complain_MuiOutlinedInput-root__M2Kos {
  border-radius: 8px;
  background-color: #fff !important;
}

.complain_filtersGrid__l22Ie {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  width: 100%;
  align-items: flex-end;
  margin-bottom: 24px;
}

.complain_buttonsContainer__u\\+g-i {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
  width: 100%;
  grid-column: span 3;
}

@media (max-width: 1280px) {
  .complain_filtersGrid__l22Ie {
    grid-template-columns: repeat(2, 1fr);
  }

  .complain_buttonsContainer__u\\+g-i {
    grid-column: span 2;
  }
}

@media (max-width: 768px) {
  .complain_filtersGrid__l22Ie {
    grid-template-columns: 1fr;
  }

  .complain_buttonsContainer__u\\+g-i {
    grid-column: span 1;
    justify-content: flex-start;
    flex-wrap: wrap;
    height: auto;
  }
}

.complain_categoryFilterControl__EjXzq {
  min-width: 220px;
}

.complain_dateContainer__kWyZu {
  position: relative;
  min-width: 240px;
}

.complain_dateTrigger__oFg6P {
  height: 40px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  text-align: left;
  width: 100%;
  color: #999ea5;
  font-size: 14px;
  cursor: pointer;
}

.complain_dateTrigger__oFg6P:hover {
  border: 1px solid #000;
}

.complain_datePopoverOnlyCal__QuXTa {
  position: absolute;
  top: 48px;
  right: 0;
  left: auto;
  z-index: 10000 !important;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.12);
  padding: 8px;
  max-height: 480px;
  max-width: 95vw;
  box-sizing: border-box;
  overflow: auto;
}

@media (max-width: 600px) {
  .complain_datePopoverOnlyCal__QuXTa {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    right: auto !important;
    left: auto !important;
    width: 90% !important;
    max-width: 340px !important;
    height: auto !important;
    max-height: 90vh !important;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 10px 10px -5px rgba(0, 0, 0, 0.15) !important;
  }

  .complain_datePopoverOnlyCal__QuXTa .rdrDateDisplayWrapper {
    display: none !important;
  }
}

@media (max-width: 360px) {
  .complain_datePopoverOnlyCal__QuXTa {
    font-size: 11px !important;
    padding: 8px !important;
  }
}

@media (max-width: 330px) {
  .complain_datePopoverOnlyCal__QuXTa {
    font-size: 10px !important;
    padding: 6px !important;
  }
}

.complain_datePopoverOnlyCal__QuXTa .rdrYearPicker select,
.complain_datePopoverOnlyCal__QuXTa .rdrMonthPicker select {
  max-height: 400px;
  overflow-y: auto;
}

.complain_datePopoverOnlyCal__QuXTa .rdrDay {
  overflow: hidden;
  border-radius: 8px;
}

.complain_datePopoverOnlyCal__QuXTa .rdrInRange,
.complain_datePopoverOnlyCal__QuXTa .rdrDayInPreview,
.complain_datePopoverOnlyCal__QuXTa .rdrDayStartPreview,
.complain_datePopoverOnlyCal__QuXTa .rdrDayEndPreview {
  background: transparent !important;
  box-shadow: none !important;
}

.complain_datePopoverOnlyCal__QuXTa .rdrSelected,
.complain_datePopoverOnlyCal__QuXTa .rdrStartEdge,
.complain_datePopoverOnlyCal__QuXTa .rdrEndEdge {
  background: #ede7f6 !important;
  border-radius: 9999px !important;
}

.complain_datePopoverOnlyCal__QuXTa .rdrStartEdge .rdrDayNumber span,
.complain_datePopoverOnlyCal__QuXTa .rdrEndEdge .rdrDayNumber span,
.complain_datePopoverOnlyCal__QuXTa .rdrSelected .rdrDayNumber span {
  color: #fff !important;
}

.complain_datePopoverOnlyCal__QuXTa .rdrDay .rdrDayNumber {
  border-radius: 9999px !important;
}

.complain_datePopoverOnlyCal__QuXTa .rdrDayNumber span {
  color: #000 !important;
  font-weight: 600;
}

.complain_resetBtn__GdJUR {
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  gap: 8px;
  cursor: pointer;
  align-items: center;
}

.complain_applyBtn__PmCnH {
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  background: #644ee5;
  color: #fff;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.complain_tableHeaderActions__j-U1H {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Table Styles */
.complain_tableContainer__fYSGL {
  border-radius: 12px;
  overflow-x: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--Neutrals-200, #e2e8f0);
}

/* .relovedComplaintsTab {
  min-width: 240px !important;
} */
.complain_tableHeaderCell__-SVHz {
  font-weight: 600;
  color: #374151;
  padding: 12px 15px;
  border-bottom: 2px solid #e5e7eb;
  overflow-x: auto;
  color: var(--Gray-500, #6b7280);
  text-overflow: ellipsis;

  /* Inter/Body small/Body small - medium */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  /* 142.857% */
  white-space: nowrap;
  min-width: fit-content;
}

.complain_tableRow__OLlJc {
  transition: background-color 0.2s ease;
}

.complain_tableRow__OLlJc:hover {
  background-color: #f9fafb;
}

.complain_tableCell__RNtou {
  padding: 16px 12px;
  border-bottom: 1px solid var(--Gray-200, #e5e7eb);
  overflow: hidden;
  color: var(--Gray-800, #1f2937);
  text-overflow: ellipsis;
  /* Inter/Body small/Body small - regular */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 142.857% */
  /* text-transform: capitalize */
}

.complain_tableCell2__VjP5F {
  padding: 16px 12px;
  border-bottom: 1px solid var(--Gray-200, #e5e7eb);
  overflow: hidden;
  color: var(--Gray-800, #1f2937);
  text-overflow: ellipsis;
  /* Inter/Body small/Body small - regular */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 142.857% */
  /* text-transform: capitalize */
}

.complain_FeetableRecord__uxZcA {
  display: table-cell;
  width: 112px;
  min-width: 112px;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
}

.complain_FeetableRecord__uxZcA>div {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  white-space: nowrap;
}

.complain_FeetableRecord__uxZcA span {
  display: inline-flex;
}

/* Status Chip Styles */
.complain_statusChip__fQ7sm {
  font-weight: 600;
  /* Inter/Body xs/Body xs - semibold */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  /* 150% */
  letter-spacing: 0.5px;
  padding: 4px;
  text-transform: capitalize;
}

.complain_statusChip__fQ7sm.complain_MuiChip-colorSuccess__C2wbe {
  background-color: #dcfce7;
  color: #166534;
}

.complain_statusChip__fQ7sm.complain_MuiChip-colorError__aXMTU {
  background-color: #fee2e2;
  color: #dc2626;
}

/* Action Button */
.complain_actionButton__FoBzv {
  color: #6b7280;
  transition: all 0.2s ease;
}

.complain_actionButton__FoBzv:hover {
  color: #374151;
  background-color: #f3f4f6;
}

.complain_actionBtn__1slrO {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  color: #6b7280;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.5s ease;
}

.complain_actionBtn__1slrO:hover {
  background-color: #d6dbe2;
  color: #374151;
}

.complain_actionBtn__1slrO:focus {
  outline: none;
}

/* Actions Menu */
.complain_actionsMenu__nU8bu {
  border-radius: 8px !important;
  min-width: 180px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
}

.complain_menuHeader__yQrjN {
  padding: 12px 16px 8px 16px;
  border-bottom: 1px solid #e5e7eb;
}

.complain_menuHeaderText__5xJxs {
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.complain_menuItem__vKmkQ {
  padding: 8px 16px;
  overflow: hidden;
  color: var(--Gray-800, #1f2937);
  text-overflow: ellipsis;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 142.857% */
}

.complain_menuItem__vKmkQ:hover {
  background-color: #f9fafb;
}

.complain_menuItemContent__KznQP {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.complain_menuIcon__2rpY5 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #6b7280;
}

.complain_menuView__5Y3F6 {
  display: flex;
  gap: 8px;
  align-items: center;
  color: '#1F2937';
}

.complain_menuItemText__RkoM6 {
  color: #374151 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}

/* Custom Pagination */
.complain_paginationContainer__--Ahh {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0px;
  /* border-top: 1px solid #e5e7eb; */
  background-color: #ffffff;
}

.complain_paginationInfo__te-mP {
  display: flex;
  align-items: center;
}

.complain_paginationText__1-2Ir {
  color: var(--Slate-500, #64748b);

  /* Inter/Body small/Body small - regular */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 142.857% */
}

.complain_paginationControls__-6Tpi {
  display: flex;
  align-items: center;
  gap: 24px;
}

/* Pagination responsiveness: prevent overflow on small screens */
@media (max-width: 768px) {
  .complain_paginationContainer__--Ahh {
    flex-wrap: wrap;
    gap: 8px;
  }

  .complain_paginationInfo__te-mP,
  .complain_paginationControls__-6Tpi {
    width: 100%;
  }

  .complain_paginationControls__-6Tpi {
    justify-content: space-between;
    flex-wrap: wrap;
    row-gap: 8px;
    column-gap: 8px;
  }

  .complain_paginationText__1-2Ir,
  .complain_pageInfo__Cy30z {
    white-space: normal;
    word-break: break-word;
  }

  .complain_rowsPerPage__ehzSm {
    min-width: 0;
    width: auto;
  }
}

@media (max-width: 600px) {
  .complain_paginationControls__-6Tpi {
    justify-content: flex-start;
    gap: 12px;
  }

  .complain_rowsPerPage__ehzSm .MuiOutlinedInput-root {
    min-width: 0;
  }
}

.complain_rowsPerPageContainer__0kQXr {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Fix width of the MUI FormControl used for rows-per-page selector */
.complain_rowsPerPage__ehzSm {
  min-width: 120px;
  width: 120px;
}

.complain_rowsPerPage__ehzSm .MuiOutlinedInput-root {
  height: 36px;
  border-radius: 8px;
}

.complain_rowsPerPageLabel__KtVKz {
  color: var(--Slate-800, #1e293b);

  /* Inter/Body small/Body small - medium */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  /* 142.857% */
  white-space: nowrap;
}

.complain_rowsPerPageSelect__528j4 {
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background-color: #ffffff;
  color: #374151;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  min-width: 60px;
}

.complain_whatsAppbtn__kp4Y8 {
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #acacac;
  padding: 4px;
}

.complain_whatsAppbtn__kp4Y8:hover {
  cursor: pointer;
  background-color: #166534;
}

.complain_whatsAppbtn__kp4Y8>svg {
  height: 100%;
  width: 100%;
}

.complain_whatsAppbtn__kp4Y8:disabled {
  background-color: #727070;
}

.complain_whatsAppbtn__kp4Y8 {
  background-color: #29a71a;
  transition: all 0.5s ease;
}

.complain_whatsAppbtn__kp4Y8:hover {
  background-color: #166534;
}

.complain_rowsPerPageSelect__528j4:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.complain_pageInfo__Cy30z {
  color: var(--Slate-800, #1e293b);

  /* Inter/Body small/Body small - medium */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  /* 142.857% */
  white-space: nowrap;
}

.complain_navigationButtons__kJKTF {
  display: flex;
  align-items: center;
  gap: 4px;
}

.complain_navButton__hoJsJ {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: #64748b;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
  outline: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.complain_greenBtn__N\\+Yql {
  background-color: #dcfce7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 4px;
  padding: 0;
  height: 24px;
  width: 24px;
  margin-right: 8px;
}

.complain_darkDreenBtn__7Qh81 {
  background-color: #166534;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 4px;
  padding: 0;
  height: 24px;
  width: 24px;
}

.complain_darkDreenBtn__7Qh81:hover {
  background-color: #0e3f21;
  cursor: pointer;
}

.complain_darkDreenBtn__7Qh81:disabled {
  background-color: #acacac;
  cursor: auto;
}

.complain_redBtn__QAQAf {
  background-color: #fee2e2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 4px;
  padding: 0;
  height: 24px;
  width: 24px;
}

.complain_whatsAppbtn__kp4Y8:disabled {
  background-color: #acacac;
  cursor: auto;
}

/* .btnsCell {
  display: flex;
  align-items: center;
  gap: 8px;
} */

.complain_btnsCell__MEutN>button:hover {
  cursor: pointer;
}

.complain_navButton__hoJsJ:hover:not(.complain_navButtonDisabled__7aetV) {
  background-color: #f8fafc;
  border-color: #cbd5e1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.complain_navButton__hoJsJ:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

.complain_navButtonText__\\+gjr8 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: inherit;
  font-family: Inter, sans-serif;
}

.complain_navButtonDisabled__7aetV {
  background-color: #f1f5f9;
  color: #94a3b8;
  cursor: not-allowed;
  border-color: #e2e8f0;
  box-shadow: none;
}

.complain_navButtonDisabled__7aetV:hover {
  background-color: #f1f5f9;
  border-color: #e2e8f0;
  transform: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.complain_pagination__xramM .complain_MuiIconButton-root__paDWn:hover {
  color: #374151;
  background-color: #f3f4f6;
}

.complain_pagination__xramM .complain_MuiIconButton-root__paDWn.complain_Mui-disabled__tLVmj {
  color: #d1d5db;
}

.complain_darkDreenBtn__7Qh81:hover {
  background-color: #0e3f21;
  cursor: pointer;
}

.complain_darkDreenBtn__7Qh81:disabled {
  background-color: #acacac;
  cursor: auto;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .complain_container__SVnbL {
    padding: 16px;
  }

  .complain_topHeader__kEX1z {
    padding: 20px;
    margin-bottom: 24px;
  }

  .complain_mainTitle__XmYwY {
    font-size: 24px;
  }

  .complain_searchField__1vEZ6 {
    width: 250px;
  }
}

@media (max-width: 768px) {
  .complain_topHeader__kEX1z {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .complain_uploadButton__9xrcV {
    align-self: flex-end;
  }

  .complain_contentHeader__Mmt1M {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .complain_searchField__1vEZ6 {
    width: 100%;
  }

  .complain_tableContainer__fYSGL {
    width: 100%;
    margin: 0 0 24px 0;
    overflow-x: auto;
  }
}

@media (max-width: 480px) {
  .complain_container__SVnbL {
    padding: 12px;
  }

  .complain_topHeader__kEX1z {
    padding: 16px;
  }

  .complain_mainContent__wTJ2X {
    padding: 16px;
  }

  .complain_mainTitle__XmYwY {
    font-size: 20px;
  }

  .complain_contentTitle__GhhNX {
    font-size: 20px;
  }
}

/* CSV Upload Modal */
.complain_uploadModalOverlay__LTJkO {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1400;
  animation: complain_fadeIn__Ywi0C 0.3s ease-out;
}

.complain_uploadModalContent__4UAiG {
  background-color: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  animation: complain_slideInUp__e-QXa 0.3s ease-out;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.complain_hidden__YMvU9 {
  display: none;
}

@keyframes complain_slideInUp__e-QXa {
  from {
    transform: translateY(50px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.complain_uploadModalHeader__-ZlN3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 16px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.complain_uploadModalTitle__Y0iNI {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.complain_uploadCloseButton__VLDLg {
  color: #6b7280;
}

.complain_uploadCloseButton__VLDLg:hover {
  color: #374151;
  background-color: #f3f4f6;
}

.complain_uploadModalBody__0fsuj {
  padding: 24px;
}

.complain_uploadSection__DiCRR {
  text-align: center;
}

.complain_uploadInstructions__4U\\+ek {
  font-size: 16px;
  color: #374151;
  margin-bottom: 20px;
  line-height: 1.5;
}

.complain_csvFormat__ao6Aw {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}

.complain_csvFormatText__mwh5g {
  font-family: 'Courier New', monospace;
  color: #6b7280;
  font-size: 14px;
}

.complain_fileUploadArea__7hvDX {
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  padding: 40px 20px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.complain_fileUploadArea__7hvDX:hover {
  border-color: #8b5cf6;
  background-color: #f5f3ff;
}

.complain_fileInput__i27bL {
  display: none;
}

.complain_fileUploadLabel__F0VD0 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  cursor: pointer;
}

.complain_uploadIcon__Bhy30 {
  font-size: 48px;
  color: #8b5cf6;
}

.complain_uploadText__1pHeP {
  font-size: 16px;
  color: #6b7280;
  font-weight: 500;
}

/* Preview Section */
.complain_previewSection__PTElV {
  text-align: left;
}

.complain_previewTitle__ikzdE {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 20px;
}

.complain_previewTable__KXIGK {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
}

.complain_previewHeader__K-KOg {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 1fr;
  background-color: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
}

.complain_previewHeaderCell__ReHeq {
  padding: 12px 16px;
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.complain_previewRow__w\\+N93 {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 1fr;
  border-bottom: 1px solid #f3f4f6;
}

.complain_previewRow__w\\+N93:last-child {
  border-bottom: none;
}

.complain_previewCell__-he4L {
  padding: 12px 16px;
  color: #6b7280;
  font-size: 14px;
}

.complain_moreStudents__pNwt4 {
  text-align: center;
  padding: 16px;
  color: #6b7280;
  font-style: italic;
  background-color: #f9fafb;
}

.complain_uploadActions__qF8\\+D {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
}

.complain_cancelButton__Ue5Zq {
  border-color: #d1d5db;
  color: #6b7280;
}

.complain_confirmButton__xmHoF {
  background-color: #8b5cf6;
  color: white;
}

.complain_confirmButton__xmHoF:hover {
  background-color: #644ee5;
}

.complain_exportBtn__-lAzZ {
  border-radius: 6px;
  background: var(--Slate-950, #020617);
  color: var(--White-White, #fff);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  /* 171.429% */
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 8px;
}

.complain_exportBtnParent__ob\\+Dm {
  display: flex;
  align-items: center;
  gap: 12px;
}

.complain_paginationBtn__JOD5b {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: #64748b;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
  outline: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.complain_paginationBtn__JOD5b:disabled {
  background-color: #f3f4f6;
}

/* ============================================================
   RESPONSIVE DESIGN
============================================================ */

/* ------------------- 1024px ------------------- */
@media (max-width: 1024px) {
  .complain_mainContent__wTJ2X {
    padding: 20px;
  }

  .complain_searchField__1vEZ6 {
    width: 250px;
  }

  .complain_topHeader__kEX1z {
    padding: 0;
  }
}

/* ------------------- 900px ------------------- */
@media (max-width: 900px) {

  .complain_tableHeaderCell__-SVHz,
  .complain_tableCell__RNtou {
    font-size: 13px;
    padding: 10px 8px;
  }
}

/* ------------------- 768px ------------------- */
@media (max-width: 768px) {
  .complain_topHeader__kEX1z {
    flex-direction: column;
    gap: 16px;
  }

  .complain_headContainer__WtstL {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    gap: 5px;
    margin-bottom: 10px;
    column-gap: 20px;
  }

  .complain_contentHeader__Mmt1M {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .complain_tab1__1OKk3 {
    min-width: 160px !important;
  }

  .complain_tab__KqMj5 {
    margin-left: 0 !important;
    min-width: 168px !important;
  }

  .complain_searchField__1vEZ6 {
    width: 100% !important;
  }

  .complain_tableContainer__fYSGL {
    overflow-x: scroll;
  }

  .complain_tableHeaderCell__-SVHz,
  .complain_tableCell__RNtou {
    font-size: 12px;
    white-space: nowrap;
  }

  .complain_paginationContainer__--Ahh {
    flex-wrap: wrap;
    gap: 12px;
  }

  .complain_paginationControls__-6Tpi {
    width: 100%;
    justify-content: space-between;
  }

  .complain_tab__KqMj5 {
    min-width: 180px;
    font-size: 13px !important;
  }

  .complain_count__mXlna {
    width: 20px !important;
    height: 20px !important;
    font-size: 12px !important;
  }
}

/* ------------------- 600px ------------------- */
@media (max-width: 600px) {
  .complain_tableHeaderCell__-SVHz {
    font-size: 11px;
  }

  .complain_tableCell__RNtou {
    font-size: 11px;
  }

  .complain_greenBtn__N\\+Yql,
  .complain_redBtn__QAQAf,
  .complain_darkDreenBtn__7Qh81 {
    width: 20px;
    height: 20px;
  }
}

/* ------------------- 480px ------------------- */
@media (max-width: 480px) {
  .complain_container__SVnbL {
    padding: 12px;
  }

  .complain_mainContent__wTJ2X {
    padding: 16px;
  }

  .complain_mainTitle__XmYwY {
    font-size: 20px;
  }

  .complain_subtitle__xxh1I {
    font-size: 12px;
  }

  .complain_paginationBtn__JOD5b {
    width: 30px;
    height: 30px;
  }

  .complain_tab__KqMj5 {
    min-width: 154px !important;
  }

  .complain_actionsMenu__nU8bu {
    min-width: 150px !important;
  }

  .complain_menuItem__vKmkQ {
    font-size: 13px;
  }

  .complain_tab__KqMj5 {
    min-width: 150px;
    font-size: 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminDashboard/Complaint_Management/complain.module.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,6BAA6B;AAC/B;;;;AAIA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;;EAEvB,sBAAsB;;EAEtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;;AAGA;EACE,SAAO;AACT;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;;EAEhB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,uBAAuB;;EAEvB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;EACzB,aAAa;;EAEb,kBAAkB;;EAElB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,gCAAgC;;EAEhC,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gCAAgC;;EAEhC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;;EAEhC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,oBAAoB;IACpB,2CAA2C;IAC3C,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,iGAAiG;EACnG;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;AACF;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;EAIE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;;EAGE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;;GAEG;AACH;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;;EAEvB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;;EAEhC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,iEAAiE;AACjE;EACE;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,SAAS;EACX;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;;EAEhC,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;;EAEhC,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;;;GAIG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,+CAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kDAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;8DAE8D;;AAE9D,mDAAmD;AACnD;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,kDAAkD;AAClD;;EAEE;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;AACF","sourcesContent":["/* Container */\n.container {\n  /* padding-top: 22px; */\n  /* background-color: #f5f5f5; */\n  min-height: calc(100% - 88px);\n}\n\n\n\n/* Top Header Section */\n.topHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  padding: 20px 0 24px 0;\n\n  border-radius: 12px;\n  color: white;\n}\n\n.globalBadge {\n  background-color: #e0f2fe;\n  /* Light blue background */\n  color: #0369a1;\n  /* Dark blue text */\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 12px;\n  text-transform: uppercase;\n  display: inline-block;\n}\n\n.noglobalBadge {\n  background-color: #FEF9C3;\n  color: #CA8A04;\n  /* Dark blue text */\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 12px;\n  text-transform: uppercase;\n  display: inline-block;\n}\n\n\n.headerLeft {\n  flex: 1;\n}\n\n.container :global(.css-rhb7ah-MuiInputBase-input-MuiOutlinedInput-input) {\n  background: #fff !important;\n}\n\n.container :global(.css-w75fiz-MuiInputBase-root-MuiOutlinedInput-root) {\n  background: #fff !important;\n}\n\n.complaintheaderParents {\n  border-bottom: 1px solid #d2d9e3;\n  margin-bottom: 24px;\n}\n\n.headContainer {\n  display: flex;\n  margin-bottom: 0;\n  /* gap: 20px; */\n  border-radius: 0;\n  padding: 0 0 0 4px;\n  font-size: 20px;\n  overflow-x: auto;\n  /* smooth scrolling */\n  scrollbar-width: none;\n  /* Firefox */\n}\n\n.headContainer::-webkit-scrollbar {\n  display: none;\n  /* Chrome, Safari, Edge */\n}\n\n.headContainer>.tab {\n  font-family: 'Inter';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 30px;\n  letter-spacing: 0%;\n  padding: 10px 14px;\n  /* min-width: 251px; */\n  gap: 10px;\n  color: #94a3b8;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -1px;\n}\n\n.tab1 {\n  min-width: 180px !important;\n}\n\n.relovedComplaintsTab {\n  min-width: 180px !important;\n}\n\n.headContainer>.tab>.count {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* width: 24px; */\n  height: 20px;\n  /* border-radius: 50%; */\n  border-radius: 100px;\n  padding: 2px 4px;\n\n  background: #ef4444;\n  font-family: 'Inter';\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n  letter-spacing: 0%;\n  color: white;\n}\n\n.headContainer>.tab:hover {\n  color: #8b5cf6;\n}\n\n.headContainer>.activeTab {\n  font-weight: 600;\n  color: #8b5cf6;\n  border-bottom-color: #8b5cf6;\n  box-shadow: none !important;\n}\n\n.tab {\n  display: flex;\n  min-width: 56px;\n  padding: 6px 12px;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  width: 100%;\n  max-width: max-content;\n  background: transparent;\n\n  /* border-radius: 6px; */\n  cursor: pointer;\n  transition: all 0.2s ease;\n  /* flex: 1; */\n\n  text-align: center;\n\n  /* Inter/Body small/Body small - medium */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  /* 142.857% */\n}\n\n.tab:hover {\n  background-color: transparent;\n  color: #625be7;\n}\n\n.mainTitle {\n  color: var(--Slate-800, #1e293b);\n\n  /* Inter/Heading 6/Heading 6 - semibold */\n  font-family: Inter;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 32px;\n  /* 133.333% */\n}\n\n.subtitle {\n  color: var(--Slate-500, #64748b);\n\n  /* Inter/Body small/Body small - regular */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  /* 142.857% */\n}\n\n.uploadButton {\n  color: white;\n  padding: 12px 24px;\n  color: var(--White, #fff);\n  /* font-family: \"Public Sans\"; */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  /* 142.857% */\n  border-radius: 8px;\n  background: var(--Violet, #644ee5);\n  transition: all 0.3s ease;\n}\n\n.uploadButton:hover {\n  background-color: #4e38b3;\n  transform: translateY(-2px);\n}\n\n/* Main Content Area */\n.mainContent {\n  background-color: #ffffff;\n  border-radius: 12px;\n  padding: 20px 24px 24px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.contentHeader {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.contentTitle {\n  color: var(--Slate-800, #1e293b);\n\n  /* Inter/Body xl/Body xl - semibold */\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 30px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  /* 150% */\n}\n\n.searchField {\n  width: 100%;\n}\n\n.searchField .MuiOutlinedInput-root {\n  border-radius: 8px;\n  background-color: #fff !important;\n}\n\n.filtersGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  width: 100%;\n  align-items: flex-end;\n  margin-bottom: 24px;\n}\n\n.buttonsContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: flex-end;\n  width: 100%;\n  grid-column: span 3;\n}\n\n@media (max-width: 1280px) {\n  .filtersGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .buttonsContainer {\n    grid-column: span 2;\n  }\n}\n\n@media (max-width: 768px) {\n  .filtersGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .buttonsContainer {\n    grid-column: span 1;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    height: auto;\n  }\n}\n\n.categoryFilterControl {\n  min-width: 220px;\n}\n\n.dateContainer {\n  position: relative;\n  min-width: 240px;\n}\n\n.dateTrigger {\n  height: 40px;\n  padding: 0 12px;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  text-align: left;\n  width: 100%;\n  color: #999ea5;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.dateTrigger:hover {\n  border: 1px solid #000;\n}\n\n.datePopoverOnlyCal {\n  position: absolute;\n  top: 48px;\n  right: 0;\n  left: auto;\n  z-index: 10000 !important;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.12);\n  padding: 8px;\n  max-height: 480px;\n  max-width: 95vw;\n  box-sizing: border-box;\n  overflow: auto;\n}\n\n@media (max-width: 600px) {\n  .datePopoverOnlyCal {\n    position: fixed !important;\n    top: 50% !important;\n    left: 50% !important;\n    transform: translate(-50%, -50%) !important;\n    right: auto !important;\n    left: auto !important;\n    width: 90% !important;\n    max-width: 340px !important;\n    height: auto !important;\n    max-height: 90vh !important;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 10px 10px -5px rgba(0, 0, 0, 0.15) !important;\n  }\n\n  .datePopoverOnlyCal :global(.rdrDateDisplayWrapper) {\n    display: none !important;\n  }\n}\n\n@media (max-width: 360px) {\n  .datePopoverOnlyCal {\n    font-size: 11px !important;\n    padding: 8px !important;\n  }\n}\n\n@media (max-width: 330px) {\n  .datePopoverOnlyCal {\n    font-size: 10px !important;\n    padding: 6px !important;\n  }\n}\n\n.datePopoverOnlyCal :global(.rdrYearPicker select),\n.datePopoverOnlyCal :global(.rdrMonthPicker select) {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.datePopoverOnlyCal :global(.rdrDay) {\n  overflow: hidden;\n  border-radius: 8px;\n}\n\n.datePopoverOnlyCal :global(.rdrInRange),\n.datePopoverOnlyCal :global(.rdrDayInPreview),\n.datePopoverOnlyCal :global(.rdrDayStartPreview),\n.datePopoverOnlyCal :global(.rdrDayEndPreview) {\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.datePopoverOnlyCal :global(.rdrSelected),\n.datePopoverOnlyCal :global(.rdrStartEdge),\n.datePopoverOnlyCal :global(.rdrEndEdge) {\n  background: #ede7f6 !important;\n  border-radius: 9999px !important;\n}\n\n.datePopoverOnlyCal :global(.rdrStartEdge .rdrDayNumber span),\n.datePopoverOnlyCal :global(.rdrEndEdge .rdrDayNumber span),\n.datePopoverOnlyCal :global(.rdrSelected .rdrDayNumber span) {\n  color: #fff !important;\n}\n\n.datePopoverOnlyCal :global(.rdrDay .rdrDayNumber) {\n  border-radius: 9999px !important;\n}\n\n.datePopoverOnlyCal :global(.rdrDayNumber span) {\n  color: #000 !important;\n  font-weight: 600;\n}\n\n.resetBtn {\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 8px;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  color: #111827;\n  font-size: 14px;\n  font-weight: 500;\n  display: flex;\n  gap: 8px;\n  cursor: pointer;\n  align-items: center;\n}\n\n.applyBtn {\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 8px;\n  background: #644ee5;\n  color: #fff;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tableHeaderActions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Table Styles */\n.tableContainer {\n  border-radius: 12px;\n  overflow-x: auto;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--Neutrals-200, #e2e8f0);\n}\n\n/* .relovedComplaintsTab {\n  min-width: 240px !important;\n} */\n.tableHeaderCell {\n  font-weight: 600;\n  color: #374151;\n  padding: 12px 15px;\n  border-bottom: 2px solid #e5e7eb;\n  overflow-x: auto;\n  color: var(--Gray-500, #6b7280);\n  text-overflow: ellipsis;\n\n  /* Inter/Body small/Body small - medium */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  /* 142.857% */\n  white-space: nowrap;\n  min-width: fit-content;\n}\n\n.tableRow {\n  transition: background-color 0.2s ease;\n}\n\n.tableRow:hover {\n  background-color: #f9fafb;\n}\n\n.tableCell {\n  padding: 16px 12px;\n  border-bottom: 1px solid var(--Gray-200, #e5e7eb);\n  overflow: hidden;\n  color: var(--Gray-800, #1f2937);\n  text-overflow: ellipsis;\n  /* Inter/Body small/Body small - regular */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  /* 142.857% */\n  /* text-transform: capitalize */\n}\n\n.tableCell2 {\n  padding: 16px 12px;\n  border-bottom: 1px solid var(--Gray-200, #e5e7eb);\n  overflow: hidden;\n  color: var(--Gray-800, #1f2937);\n  text-overflow: ellipsis;\n  /* Inter/Body small/Body small - regular */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  /* 142.857% */\n  /* text-transform: capitalize */\n}\n\n.FeetableRecord {\n  display: table-cell;\n  width: 112px;\n  min-width: 112px;\n  text-align: center;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.FeetableRecord>div {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.FeetableRecord span {\n  display: inline-flex;\n}\n\n/* Status Chip Styles */\n.statusChip {\n  font-weight: 600;\n  /* Inter/Body xs/Body xs - semibold */\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px;\n  /* 150% */\n  letter-spacing: 0.5px;\n  padding: 4px;\n  text-transform: capitalize;\n}\n\n.statusChip.MuiChip-colorSuccess {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.statusChip.MuiChip-colorError {\n  background-color: #fee2e2;\n  color: #dc2626;\n}\n\n/* Action Button */\n.actionButton {\n  color: #6b7280;\n  transition: all 0.2s ease;\n}\n\n.actionButton:hover {\n  color: #374151;\n  background-color: #f3f4f6;\n}\n\n.actionBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background-color: transparent;\n  color: #6b7280;\n  padding: 4px;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.5s ease;\n}\n\n.actionBtn:hover {\n  background-color: #d6dbe2;\n  color: #374151;\n}\n\n.actionBtn:focus {\n  outline: none;\n}\n\n/* Actions Menu */\n.actionsMenu {\n  border-radius: 8px !important;\n  min-width: 180px !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;\n}\n\n.menuHeader {\n  padding: 12px 16px 8px 16px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.menuHeaderText {\n  color: #6b7280;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.menuItem {\n  padding: 8px 16px;\n  overflow: hidden;\n  color: var(--Gray-800, #1f2937);\n  text-overflow: ellipsis;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  /* 142.857% */\n}\n\n.menuItem:hover {\n  background-color: #f9fafb;\n}\n\n.menuItemContent {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.menuIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  color: #6b7280;\n}\n\n.menuView {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  color: '#1F2937';\n}\n\n.menuItemText {\n  color: #374151 !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n}\n\n/* Custom Pagination */\n.paginationContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 0px;\n  /* border-top: 1px solid #e5e7eb; */\n  background-color: #ffffff;\n}\n\n.paginationInfo {\n  display: flex;\n  align-items: center;\n}\n\n.paginationText {\n  color: var(--Slate-500, #64748b);\n\n  /* Inter/Body small/Body small - regular */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  /* 142.857% */\n}\n\n.paginationControls {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n/* Pagination responsiveness: prevent overflow on small screens */\n@media (max-width: 768px) {\n  .paginationContainer {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .paginationInfo,\n  .paginationControls {\n    width: 100%;\n  }\n\n  .paginationControls {\n    justify-content: space-between;\n    flex-wrap: wrap;\n    row-gap: 8px;\n    column-gap: 8px;\n  }\n\n  .paginationText,\n  .pageInfo {\n    white-space: normal;\n    word-break: break-word;\n  }\n\n  .rowsPerPage {\n    min-width: 0;\n    width: auto;\n  }\n}\n\n@media (max-width: 600px) {\n  .paginationControls {\n    justify-content: flex-start;\n    gap: 12px;\n  }\n\n  .rowsPerPage :global(.MuiOutlinedInput-root) {\n    min-width: 0;\n  }\n}\n\n.rowsPerPageContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Fix width of the MUI FormControl used for rows-per-page selector */\n.rowsPerPage {\n  min-width: 120px;\n  width: 120px;\n}\n\n.rowsPerPage :global(.MuiOutlinedInput-root) {\n  height: 36px;\n  border-radius: 8px;\n}\n\n.rowsPerPageLabel {\n  color: var(--Slate-800, #1e293b);\n\n  /* Inter/Body small/Body small - medium */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  /* 142.857% */\n  white-space: nowrap;\n}\n\n.rowsPerPageSelect {\n  padding: 4px 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  background-color: #ffffff;\n  color: #374151;\n  font-size: 14px;\n  cursor: pointer;\n  outline: none;\n  min-width: 60px;\n}\n\n.whatsAppbtn {\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #acacac;\n  padding: 4px;\n}\n\n.whatsAppbtn:hover {\n  cursor: pointer;\n  background-color: #166534;\n}\n\n.whatsAppbtn>svg {\n  height: 100%;\n  width: 100%;\n}\n\n.whatsAppbtn:disabled {\n  background-color: #727070;\n}\n\n.whatsAppbtn {\n  background-color: #29a71a;\n  transition: all 0.5s ease;\n}\n\n.whatsAppbtn:hover {\n  background-color: #166534;\n}\n\n.rowsPerPageSelect:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n\n.pageInfo {\n  color: var(--Slate-800, #1e293b);\n\n  /* Inter/Body small/Body small - medium */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  /* 142.857% */\n  white-space: nowrap;\n}\n\n.navigationButtons {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.navButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  color: #64748b;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  outline: none;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.greenBtn {\n  background-color: #dcfce7;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 4px;\n  padding: 0;\n  height: 24px;\n  width: 24px;\n  margin-right: 8px;\n}\n\n.darkDreenBtn {\n  background-color: #166534;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 4px;\n  padding: 0;\n  height: 24px;\n  width: 24px;\n}\n\n.darkDreenBtn:hover {\n  background-color: #0e3f21;\n  cursor: pointer;\n}\n\n.darkDreenBtn:disabled {\n  background-color: #acacac;\n  cursor: auto;\n}\n\n.redBtn {\n  background-color: #fee2e2;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 4px;\n  padding: 0;\n  height: 24px;\n  width: 24px;\n}\n\n.whatsAppbtn:disabled {\n  background-color: #acacac;\n  cursor: auto;\n}\n\n/* .btnsCell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n} */\n\n.btnsCell>button:hover {\n  cursor: pointer;\n}\n\n.navButton:hover:not(.navButtonDisabled) {\n  background-color: #f8fafc;\n  border-color: #cbd5e1;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n  transform: translateY(-1px);\n}\n\n.navButton:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n.navButtonText {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  color: inherit;\n  font-family: Inter, sans-serif;\n}\n\n.navButtonDisabled {\n  background-color: #f1f5f9;\n  color: #94a3b8;\n  cursor: not-allowed;\n  border-color: #e2e8f0;\n  box-shadow: none;\n}\n\n.navButtonDisabled:hover {\n  background-color: #f1f5f9;\n  border-color: #e2e8f0;\n  transform: none;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.pagination .MuiIconButton-root:hover {\n  color: #374151;\n  background-color: #f3f4f6;\n}\n\n.pagination .MuiIconButton-root.Mui-disabled {\n  color: #d1d5db;\n}\n\n.darkDreenBtn:hover {\n  background-color: #0e3f21;\n  cursor: pointer;\n}\n\n.darkDreenBtn:disabled {\n  background-color: #acacac;\n  cursor: auto;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .container {\n    padding: 16px;\n  }\n\n  .topHeader {\n    padding: 20px;\n    margin-bottom: 24px;\n  }\n\n  .mainTitle {\n    font-size: 24px;\n  }\n\n  .searchField {\n    width: 250px;\n  }\n}\n\n@media (max-width: 768px) {\n  .topHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .uploadButton {\n    align-self: flex-end;\n  }\n\n  .contentHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .searchField {\n    width: 100%;\n  }\n\n  .tableContainer {\n    width: 100%;\n    margin: 0 0 24px 0;\n    overflow-x: auto;\n  }\n}\n\n@media (max-width: 480px) {\n  .container {\n    padding: 12px;\n  }\n\n  .topHeader {\n    padding: 16px;\n  }\n\n  .mainContent {\n    padding: 16px;\n  }\n\n  .mainTitle {\n    font-size: 20px;\n  }\n\n  .contentTitle {\n    font-size: 20px;\n  }\n}\n\n/* CSV Upload Modal */\n.uploadModalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1400;\n  animation: fadeIn 0.3s ease-out;\n}\n\n.uploadModalContent {\n  background-color: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  overflow-y: auto;\n  animation: slideInUp 0.3s ease-out;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n.hidden {\n  display: none;\n}\n\n@keyframes slideInUp {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.uploadModalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 24px 16px 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.uploadModalTitle {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.uploadCloseButton {\n  color: #6b7280;\n}\n\n.uploadCloseButton:hover {\n  color: #374151;\n  background-color: #f3f4f6;\n}\n\n.uploadModalBody {\n  padding: 24px;\n}\n\n.uploadSection {\n  text-align: center;\n}\n\n.uploadInstructions {\n  font-size: 16px;\n  color: #374151;\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n.csvFormat {\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 24px;\n}\n\n.csvFormatText {\n  font-family: 'Courier New', monospace;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.fileUploadArea {\n  border: 2px dashed #d1d5db;\n  border-radius: 8px;\n  padding: 40px 20px;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.fileUploadArea:hover {\n  border-color: #8b5cf6;\n  background-color: #f5f3ff;\n}\n\n.fileInput {\n  display: none;\n}\n\n.fileUploadLabel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  cursor: pointer;\n}\n\n.uploadIcon {\n  font-size: 48px;\n  color: #8b5cf6;\n}\n\n.uploadText {\n  font-size: 16px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n/* Preview Section */\n.previewSection {\n  text-align: left;\n}\n\n.previewTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 20px;\n}\n\n.previewTable {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 24px;\n}\n\n.previewHeader {\n  display: grid;\n  grid-template-columns: 1fr 2fr 2fr 1fr;\n  background-color: #f8fafc;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.previewHeaderCell {\n  padding: 12px 16px;\n  font-weight: 600;\n  color: #374151;\n  font-size: 14px;\n}\n\n.previewRow {\n  display: grid;\n  grid-template-columns: 1fr 2fr 2fr 1fr;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.previewRow:last-child {\n  border-bottom: none;\n}\n\n.previewCell {\n  padding: 12px 16px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.moreStudents {\n  text-align: center;\n  padding: 16px;\n  color: #6b7280;\n  font-style: italic;\n  background-color: #f9fafb;\n}\n\n.uploadActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n  margin-top: 24px;\n}\n\n.cancelButton {\n  border-color: #d1d5db;\n  color: #6b7280;\n}\n\n.confirmButton {\n  background-color: #8b5cf6;\n  color: white;\n}\n\n.confirmButton:hover {\n  background-color: #644ee5;\n}\n\n.exportBtn {\n  border-radius: 6px;\n  background: var(--Slate-950, #020617);\n  color: var(--White-White, #fff);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  /* 171.429% */\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n  gap: 8px;\n}\n\n.exportBtnParent {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.paginationBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  color: #64748b;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  outline: none;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.paginationBtn:disabled {\n  background-color: #f3f4f6;\n}\n\n/* ============================================================\n   RESPONSIVE DESIGN\n============================================================ */\n\n/* ------------------- 1024px ------------------- */\n@media (max-width: 1024px) {\n  .mainContent {\n    padding: 20px;\n  }\n\n  .searchField {\n    width: 250px;\n  }\n\n  .topHeader {\n    padding: 0;\n  }\n}\n\n/* ------------------- 900px ------------------- */\n@media (max-width: 900px) {\n\n  .tableHeaderCell,\n  .tableCell {\n    font-size: 13px;\n    padding: 10px 8px;\n  }\n}\n\n/* ------------------- 768px ------------------- */\n@media (max-width: 768px) {\n  .topHeader {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .headContainer {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    width: 100%;\n    gap: 5px;\n    margin-bottom: 10px;\n    column-gap: 20px;\n  }\n\n  .contentHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .tab1 {\n    min-width: 160px !important;\n  }\n\n  .tab {\n    margin-left: 0 !important;\n    min-width: 168px !important;\n  }\n\n  .searchField {\n    width: 100% !important;\n  }\n\n  .tableContainer {\n    overflow-x: scroll;\n  }\n\n  .tableHeaderCell,\n  .tableCell {\n    font-size: 12px;\n    white-space: nowrap;\n  }\n\n  .paginationContainer {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .paginationControls {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .tab {\n    min-width: 180px;\n    font-size: 13px !important;\n  }\n\n  .count {\n    width: 20px !important;\n    height: 20px !important;\n    font-size: 12px !important;\n  }\n}\n\n/* ------------------- 600px ------------------- */\n@media (max-width: 600px) {\n  .tableHeaderCell {\n    font-size: 11px;\n  }\n\n  .tableCell {\n    font-size: 11px;\n  }\n\n  .greenBtn,\n  .redBtn,\n  .darkDreenBtn {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n/* ------------------- 480px ------------------- */\n@media (max-width: 480px) {\n  .container {\n    padding: 12px;\n  }\n\n  .mainContent {\n    padding: 16px;\n  }\n\n  .mainTitle {\n    font-size: 20px;\n  }\n\n  .subtitle {\n    font-size: 12px;\n  }\n\n  .paginationBtn {\n    width: 30px;\n    height: 30px;\n  }\n\n  .tab {\n    min-width: 154px !important;\n  }\n\n  .actionsMenu {\n    min-width: 150px !important;\n  }\n\n  .menuItem {\n    font-size: 13px;\n  }\n\n  .tab {\n    min-width: 150px;\n    font-size: 12px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `complain_container__SVnbL`,
	"topHeader": `complain_topHeader__kEX1z`,
	"globalBadge": `complain_globalBadge__qgLKr`,
	"noglobalBadge": `complain_noglobalBadge__YQTh7`,
	"headerLeft": `complain_headerLeft__sq8Ck`,
	"complaintheaderParents": `complain_complaintheaderParents__npqPc`,
	"headContainer": `complain_headContainer__WtstL`,
	"tab": `complain_tab__KqMj5`,
	"tab1": `complain_tab1__1OKk3`,
	"relovedComplaintsTab": `complain_relovedComplaintsTab__0ZFdG`,
	"count": `complain_count__mXlna`,
	"activeTab": `complain_activeTab__KX9Yg`,
	"mainTitle": `complain_mainTitle__XmYwY`,
	"subtitle": `complain_subtitle__xxh1I`,
	"uploadButton": `complain_uploadButton__9xrcV`,
	"mainContent": `complain_mainContent__wTJ2X`,
	"contentHeader": `complain_contentHeader__Mmt1M`,
	"contentTitle": `complain_contentTitle__GhhNX`,
	"searchField": `complain_searchField__1vEZ6`,
	"MuiOutlinedInput-root": `complain_MuiOutlinedInput-root__M2Kos`,
	"filtersGrid": `complain_filtersGrid__l22Ie`,
	"buttonsContainer": `complain_buttonsContainer__u+g-i`,
	"categoryFilterControl": `complain_categoryFilterControl__EjXzq`,
	"dateContainer": `complain_dateContainer__kWyZu`,
	"dateTrigger": `complain_dateTrigger__oFg6P`,
	"datePopoverOnlyCal": `complain_datePopoverOnlyCal__QuXTa`,
	"resetBtn": `complain_resetBtn__GdJUR`,
	"applyBtn": `complain_applyBtn__PmCnH`,
	"tableHeaderActions": `complain_tableHeaderActions__j-U1H`,
	"tableContainer": `complain_tableContainer__fYSGL`,
	"tableHeaderCell": `complain_tableHeaderCell__-SVHz`,
	"tableRow": `complain_tableRow__OLlJc`,
	"tableCell": `complain_tableCell__RNtou`,
	"tableCell2": `complain_tableCell2__VjP5F`,
	"FeetableRecord": `complain_FeetableRecord__uxZcA`,
	"statusChip": `complain_statusChip__fQ7sm`,
	"MuiChip-colorSuccess": `complain_MuiChip-colorSuccess__C2wbe`,
	"MuiChip-colorError": `complain_MuiChip-colorError__aXMTU`,
	"actionButton": `complain_actionButton__FoBzv`,
	"actionBtn": `complain_actionBtn__1slrO`,
	"actionsMenu": `complain_actionsMenu__nU8bu`,
	"menuHeader": `complain_menuHeader__yQrjN`,
	"menuHeaderText": `complain_menuHeaderText__5xJxs`,
	"menuItem": `complain_menuItem__vKmkQ`,
	"menuItemContent": `complain_menuItemContent__KznQP`,
	"menuIcon": `complain_menuIcon__2rpY5`,
	"menuView": `complain_menuView__5Y3F6`,
	"menuItemText": `complain_menuItemText__RkoM6`,
	"paginationContainer": `complain_paginationContainer__--Ahh`,
	"paginationInfo": `complain_paginationInfo__te-mP`,
	"paginationText": `complain_paginationText__1-2Ir`,
	"paginationControls": `complain_paginationControls__-6Tpi`,
	"pageInfo": `complain_pageInfo__Cy30z`,
	"rowsPerPage": `complain_rowsPerPage__ehzSm`,
	"rowsPerPageContainer": `complain_rowsPerPageContainer__0kQXr`,
	"rowsPerPageLabel": `complain_rowsPerPageLabel__KtVKz`,
	"rowsPerPageSelect": `complain_rowsPerPageSelect__528j4`,
	"whatsAppbtn": `complain_whatsAppbtn__kp4Y8`,
	"navigationButtons": `complain_navigationButtons__kJKTF`,
	"navButton": `complain_navButton__hoJsJ`,
	"greenBtn": `complain_greenBtn__N+Yql`,
	"darkDreenBtn": `complain_darkDreenBtn__7Qh81`,
	"redBtn": `complain_redBtn__QAQAf`,
	"btnsCell": `complain_btnsCell__MEutN`,
	"navButtonDisabled": `complain_navButtonDisabled__7aetV`,
	"navButtonText": `complain_navButtonText__+gjr8`,
	"pagination": `complain_pagination__xramM`,
	"MuiIconButton-root": `complain_MuiIconButton-root__paDWn`,
	"Mui-disabled": `complain_Mui-disabled__tLVmj`,
	"uploadModalOverlay": `complain_uploadModalOverlay__LTJkO`,
	"fadeIn": `complain_fadeIn__Ywi0C`,
	"uploadModalContent": `complain_uploadModalContent__4UAiG`,
	"slideInUp": `complain_slideInUp__e-QXa`,
	"hidden": `complain_hidden__YMvU9`,
	"uploadModalHeader": `complain_uploadModalHeader__-ZlN3`,
	"uploadModalTitle": `complain_uploadModalTitle__Y0iNI`,
	"uploadCloseButton": `complain_uploadCloseButton__VLDLg`,
	"uploadModalBody": `complain_uploadModalBody__0fsuj`,
	"uploadSection": `complain_uploadSection__DiCRR`,
	"uploadInstructions": `complain_uploadInstructions__4U+ek`,
	"csvFormat": `complain_csvFormat__ao6Aw`,
	"csvFormatText": `complain_csvFormatText__mwh5g`,
	"fileUploadArea": `complain_fileUploadArea__7hvDX`,
	"fileInput": `complain_fileInput__i27bL`,
	"fileUploadLabel": `complain_fileUploadLabel__F0VD0`,
	"uploadIcon": `complain_uploadIcon__Bhy30`,
	"uploadText": `complain_uploadText__1pHeP`,
	"previewSection": `complain_previewSection__PTElV`,
	"previewTitle": `complain_previewTitle__ikzdE`,
	"previewTable": `complain_previewTable__KXIGK`,
	"previewHeader": `complain_previewHeader__K-KOg`,
	"previewHeaderCell": `complain_previewHeaderCell__ReHeq`,
	"previewRow": `complain_previewRow__w+N93`,
	"previewCell": `complain_previewCell__-he4L`,
	"moreStudents": `complain_moreStudents__pNwt4`,
	"uploadActions": `complain_uploadActions__qF8+D`,
	"cancelButton": `complain_cancelButton__Ue5Zq`,
	"confirmButton": `complain_confirmButton__xmHoF`,
	"exportBtn": `complain_exportBtn__-lAzZ`,
	"exportBtnParent": `complain_exportBtnParent__ob+Dm`,
	"paginationBtn": `complain_paginationBtn__JOD5b`
};
export default ___CSS_LOADER_EXPORT___;
